import { render, staticRenderFns } from "./IdentificationDocumentAdditionalData.vue?vue&type=template&id=54b84b34&scoped=true"
import script from "./IdentificationDocumentAdditionalData.vue?vue&type=script&lang=js"
export * from "./IdentificationDocumentAdditionalData.vue?vue&type=script&lang=js"
import style0 from "./IdentificationDocumentAdditionalData.vue?vue&type=style&index=0&id=54b84b34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b84b34",
  null
  
)

export default component.exports